export const COLLECTION_INDEXER = "Sharedo.Core.Case.DataGraph.FieldQueries.CollectionIndexer";
export const DROPDOWN_INDEXER = "Sharedo.Core.Case.DataGraph.FieldQueries.DropdownIndexer";
export const ROLE_ASPECT_INDEXER = "Sharedo.Core.Case.DataGraph.FieldQueries.RoleAspectIndexer";
export const ROLE_INDEXER = "Sharedo.Core.Case.DataGraph.FieldQueries.RoleIndexer";